<div class="daily-summary">
  <div class="summary-title">Day demand</div>
  <div class="summary-total">
    <span class="total-value">{{ totalCount }}</span>
    <span class="total-label">games</span>
  </div>
  <ul *ngIf="breakdownEntries.length > 0" class="breakdown">
    <li *ngFor="let entry of breakdownEntries">
      <span class="key">{{ entry.key }}</span>
      <span class="value">{{ entry.value }}</span>
    </li>
  </ul>
  <div *ngIf="breakdownEntries.length === 0" class="empty"
    >No games scheduled</div
  >
</div>
